import { createSelector } from 'reselect';
import { get } from 'lodash';
import { ADMIN_ROOT_PATH, TIMETABLE_PATH } from '../constants/routes';

const router = state => state.router;

export const currentPath = createSelector(router, r => get(r, 'location.pathname'));
export const fromPath = createSelector(router, r => get(r, 'location.state.from.pathname'));

export const isAdminRoute = createSelector(currentPath, path => (path || '').includes(ADMIN_ROOT_PATH));
export const isTimetable = createSelector(currentPath, path =>
    (path || '').includes(TIMETABLE_PATH.replace(':id', ''))
);



// WEBPACK FOOTER //
// ./src/selectors/router.js